import { useCallback } from 'react';

import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridActionsCellItem } from '@mui/x-data-grid';

import type { FileItem } from './types/file-item.type';

interface DeleteActionProps {
  readonly file: FileItem;
  readonly onDelete: (file: FileItem) => void;
}

export const DeleteAction = ({
  file,
  onDelete,
}: Readonly<DeleteActionProps>) => {
  const handleClick = useCallback(() => {
    onDelete(file);
  }, [file, onDelete]);

  const actionLabel = 'Supprimer';

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={actionLabel}>
          <DeleteIcon color="error" fontSize="inherit" />
        </Tooltip>
      }
      label={actionLabel}
      onClick={handleClick}
    />
  );
};
